import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';
import queryString from 'query-string';
import { ChallengeButton, commonConstant } from '../../../common';
import { BEGIN_MEMBER_SCORE_TARGET, CHALLENGE, ChallengeTeamdashboardStatus, rectBadgeClassname } from '../../../common/challengeConstants';
import { challengeOngoingStatus, checkAfterWeightPeriod, getDataFromSession, getParamsString, isEmptyObject } from '../../../utill.func';
import BeginChallengeDashboardHeader from './beginChallengeDashBoardHeader/BeginChallengeDashboardHeader';
import TeamBeginMemberCarousel from './teamBeginMemberCarousel/TeamBeginMemberCarousel';
import TeamScoreSummaryCard from './teamScoreSummaryCard/TeamScoreSummaryCard';
import TeamBeginRewardSection from './teamBeginRewardSection/TeamBeginRewardSection';
import TeamHealthSpanScoreCard from './teamHealthSpanScoreCard/TeamHealthSpanScoreCard';
import './BeginChallengeTeamDashboard.scss';
import { fetchBeginChallengeDetail, fetchBeginChallengeTeamDetail, fetchBeginUserDetailsData } from '../../../actions';
import { TeamDashboardCompositionLoader, TeamDashboardLoader, TeamDashboardStepsLoader } from '../challengeTeamDashboard';


const BeginChallengeTeamDashboard = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();

  const { teamData: beginTeamData, userDetail, loading } = useSelector(
    (state) => state.beginChallengeTeamDashboard,
  );
  
  const beginSelectedChallenge = useSelector(
    (state) => state.challengeListObj?.beginSelectedChallenge?.challengeDetails,
  );
  
  //challenge statuses
  const challengeStatus = beginTeamData?.teamDashboardStatus?.status;
  const isChallengeOngoing = challengeOngoingStatus(challengeStatus, ChallengeTeamdashboardStatus.begin_ongoing);
  const isChallengeWaiting = challengeStatus == ChallengeTeamdashboardStatus.begin_ready_to_start || challengeStatus == ChallengeTeamdashboardStatus.begin_add_member;
  const isChallengeCompleted= checkAfterWeightPeriod(challengeStatus);

  const challengeHeaderDate = !isChallengeCompleted ? beginTeamData?.teamDashboardStatus?.header : '';

  const params = queryString.parse(location.search);
  const challengeId = params['challengeId'] || beginTeamData?.eventId;
  const eventId = params['eventId'];

  const customer = getDataFromSession('customer');
  const challengeData = getDataFromSession('beginChallengeData');
  const eventType = challengeData?.eventType;

  const backgroundImage = challengeData?.teamDashboardImg
    ? challengeData?.teamDashboardImg
    : beginSelectedChallenge?.teamDashboardImage;


  const [isHeaderSticky, setIsHeaderSticky] = useState(false);
  const [notiLoader, setNotiLoader] = useState(false);
  const [syncLoader, setSyncLoader] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsHeaderSticky(window.scrollY > 30);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    let customerData = customer?.partyId == undefined;
    setNotiLoader(customerData);
  }, [customer?.partyId]);

  const getBeginChallengeTeamDashboardData = async () => {
    try {
      await dispatch(
        fetchBeginChallengeTeamDetail({
          amwayNumber: customer?.amwayNumber || params['aboId'],
          partyId: customer?.partyId || params['partyId'],
          challengeId,
        }),
      );
    } catch (error) {
      throw error;
    } finally {
      setSyncLoader(true);
    }
  };

  useEffect(() => {
    let intervalId;
    // calling api after every 2.5 minutes to sync data from challenge api
    getBeginChallengeTeamDashboardData();
    intervalId = setInterval(
      getBeginChallengeTeamDashboardData,
      CHALLENGE.teamDashboard.refreshInterval,
    );
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
        setSyncLoader(false);
      }
    };
  }, [customer?.partyId]);

  const handleChallengeDetailRedirection = () => {
    const params = {
      challengeId: challengeId,
      eventId: eventId,
      isRegistered: true,
    };
    history.push(
      `${commonConstant.pathBeginChallengeDetail}?${getParamsString(params)}`,
    );
  };

  const handleCheckListClick = () => {
    if(!beginTeamData?.currentUserSubmittedChecklistToday){
      const params = {
        challengeId: challengeId,
        eventId: eventId,
        challengeHeaderDate: challengeHeaderDate
      };
      history.push(
        `${commonConstant.pathBeginChallengeChecklist}?${getParamsString(params)}`,
      );
    }
  }

  useEffect(() => {
    const didMount = () => {
      if (beginTeamData?.challengePartyIds && userDetail.length == 0) {
        getChallengeUserProfileData();
      }
    };
    didMount();
  }, [beginTeamData?.challengePartyIds]);

  const getChallengeUserProfileData = async () => {
    if (beginTeamData?.challengePartyIds) {
      await dispatch(fetchBeginUserDetailsData(beginTeamData?.challengePartyIds));
    }
  };

  const fetchDetail = async (id) => {
    try {
      await dispatch(fetchBeginChallengeDetail(id));
    } catch (error) {
      throw error;
    }
  };

  useEffect(() => {
    if (!beginSelectedChallenge || isEmptyObject(beginSelectedChallenge)) {
      fetchDetail(challengeId);
    }
  }, []);

 return (
    <div 
      className="begin-team-dashboard-container"
      style={backgroundImage ? { '--dynamic-bg-image': `url(${backgroundImage})` } : undefined}
    >
      <div className="begin-team-dashboard-body">
        <BeginChallengeDashboardHeader
          badgeClassname={rectBadgeClassname[challengeStatus]}
          date={challengeHeaderDate}
          isHeaderSticky={isHeaderSticky}
        />
 
 
        {(loading || notiLoader) && !syncLoader ? (
          <TeamDashboardStepsLoader />
        ) : (
          <TeamScoreSummaryCard
            teamName={beginTeamData.teamName}
            primaryTitle={CHALLENGE.beginTeamDashboard.summaryCardPrimarytitle}
            primaryValue={beginTeamData.teamTotalChecklistScore}
            primaryTarget={beginTeamData?.teamFullSize * BEGIN_MEMBER_SCORE_TARGET}
            primarySubtitle={`เฉลี่ย ${beginTeamData.avgChecklistScorePerMember} ต่อสมาชิก`}
            secondaryTitle={CHALLENGE.beginTeamDashboard.summaryCardSecondarytitle}
            secondaryValue={beginTeamData.membersWithChecklistScore || 0}
            secondaryTarget={beginTeamData?.teamFullSize}
            secondarySubtitle={CHALLENGE.beginTeamDashboard.summaryCardSecondarySubtitle}
          />
        )}

        {isChallengeCompleted && (
          (loading || notiLoader) && !syncLoader ? (
            <TeamDashboardCompositionLoader />
          ) : (
            <TeamHealthSpanScoreCard
              title={CHALLENGE.beginTeamDashboard.teamHealthspanCardTitle}
              dateRangeSubtitle={CHALLENGE.beginTeamDashboard.teamHealthspanCardSubtitle}
              score={beginTeamData.currentUserWeightoutHealthspanScore || '-'}
              requirementText={`${CHALLENGE.beginTeamDashboard.healthspanScoreCardtext1} ${beginTeamData.currentUserHealthspanScoreTarget} ${CHALLENGE.beginTeamDashboard.healthspanScoreCardtext2}`}
            />
          )
        )}
 
        {(loading || notiLoader) && !syncLoader ? (
          <TeamDashboardLoader />
        ) : (
          <TeamBeginMemberCarousel
            teamSize={beginTeamData?.teamSize}
            teamFullSize={beginTeamData?.teamFullSize}
            teamData={beginTeamData?.users}
            scoreTarget={BEGIN_MEMBER_SCORE_TARGET}
            challengeUserData={userDetail}
          />
        )}
 
        {(loading || notiLoader) && !syncLoader ? (
          <TeamDashboardCompositionLoader />
        ) : (
          <TeamBeginRewardSection
            title="รางวัลกิจกรรม"
            rewardData={beginTeamData?.teamRewards}
          />
        )}
      </div>
 
      <div className="begin-team-dashboard-footer">
        {(loading || notiLoader) && !syncLoader ? null : (
          <>
            {isChallengeOngoing && !isChallengeWaiting && (
              <ChallengeButton
                btnTitle={CHALLENGE.beginTeamDashboard.dashboardFooterLeftBtnTitle}
                successBtn={!beginTeamData?.currentUserSubmittedChecklistToday}
                disabledBtn={beginTeamData?.currentUserSubmittedChecklistToday}
                onBtnClick={handleCheckListClick}
              />
            )}
            <ChallengeButton
              btnTitle={
                !isChallengeWaiting
                  ? CHALLENGE.beginTeamDashboard.dashboardFooterWaitingBtnTitle
                  : CHALLENGE.beginTeamDashboard.dashboardFooterRightBtnTitle
              }
              successBtn={true}
              onBtnClick={handleChallengeDetailRedirection}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default BeginChallengeTeamDashboard;